import { render, staticRenderFns } from "./dataSelect.vue?vue&type=template&id=6f5f9dbe&scoped=true&"
import script from "./dataSelect.vue?vue&type=script&lang=js&"
export * from "./dataSelect.vue?vue&type=script&lang=js&"
import style0 from "./dataSelect.vue?vue&type=style&index=0&id=6f5f9dbe&lang=less&scoped=true&"
import style1 from "./dataSelect.vue?vue&type=style&index=1&id=6f5f9dbe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5f9dbe",
  null
  
)

export default component.exports